<template>
  <el-pagination class="l-page" background :layout="layout" v-on="$listeners" v-bind="$attrs">
  </el-pagination>
</template>

<script>

  export default {
    name: 'l-page',
    props: {
      layout: {
        type: String,
        default:'total,sizes,prev, pager, next,jumper'
      }
    },
    data() {
      return {

      }
    },
    mounted() {

    }
  }
</script>

<style lang="scss" scoped>
  .l-page {
    margin-top: 10px;
    margin-bottom: 10px;
    text-align: center;
  }
</style>
